import '@fontsource/patrick-hand';
import '@fontsource/barlow-condensed';
import '@fontsource/just-another-hand';
import '@fontsource/shadows-into-light-two';

import "./src/styles/global.css";

export const onRouteUpdate = () => {
  const processImages = () => {
    const images = document.querySelectorAll("img");

    images.forEach((image) => {

      if (
        image.classList.contains("done")
      ) {
        return;
      }

      const wrapper = document.createElement("div");

      // Apply dynamic styles from the 'data-style' attribute
      const style = image.getAttribute("data-style");
      if (style) {
        style.split(";").forEach((rule) => {
          const [property, value] = rule.split(":").map((s) => s.trim());
          if (property && value) {
            wrapper.style[property] = value;
          }
        });
      }

      image.classList.add("done")

      if (
        image.classList.contains("no-tape") ||
        image.closest(".image-modal") || // Skip images inside the modal container
        image.parentElement?.classList.contains("image-wrapper")
      ) {
        image.parentNode.insertBefore(wrapper, image);
        return;
      }

      // Create a wrapper around the image
      wrapper.className = "image-wrapper";

      image.classList.forEach(element => {
        wrapper.classList.add(element)
      });

      image.className = "";

      // Move the image into the wrapper
      image.parentNode.insertBefore(wrapper, image);
      wrapper.appendChild(image);

      // Add a caption if 'data-caption' exists
      const captionText = image.getAttribute("data-caption");
      if (captionText) {
        const caption = document.createElement("p");
        caption.className = "caption";
        caption.textContent = captionText;
        wrapper.appendChild(caption);
      }

      // Select two random corners for tape
      const corners = ["top-left", "top-right", "bottom-left", "bottom-right"];
      const chosenCorners = corners.sort(() => Math.random() - 0.5).slice(0, 2);
      wrapper.classList.add(`teip-${chosenCorners[0]}`);
      wrapper.classList.add(`teip-${chosenCorners[1]}`);
    

      // Add modal functionality
      if (!image.classList.contains("modal-enabled")) {
        image.classList.add("modal-enabled");

        // Attach click event for modal
        image.addEventListener("click", () => {
          // Create modal element
          const modal = document.createElement("div");
          modal.className = "image-modal";

          // Add close button
          const closeButton = document.createElement("button");
          closeButton.className = "close-button";
          closeButton.innerHTML = "&times;";
          closeButton.addEventListener("click", () => {
            modal.remove();
            document.body.style.overflow = ""; // Restore scrolling
          });

          modal.innerHTML = `
            <div class="modal-content">
              <img src="${image.src}" alt="${image.alt}" />
            </div>
          `;

          // Append close button and modal
          modal.appendChild(closeButton);

          // Prevent background scrolling
          document.body.style.overflow = "hidden";

          // Append modal to body
          document.body.appendChild(modal);

          // Close modal on click outside image
          modal.addEventListener("click", (event) => {
            if (event.target === modal) {
              modal.remove();
              document.body.style.overflow = ""; // Restore scrolling
            }
          });
        });
      }
    });
  };

  // Initial processing of images
  processImages();

  // Observe DOM changes for dynamically added images
  const observer = new MutationObserver(() => {
    processImages();
  });

  observer.observe(document.body, { childList: true, subtree: true });
};